import type { BehindTheAnswerWidgetSchemaType } from '@inference.engine/widgets/web';
import { useTranslation } from 'react-i18next';
import { personaLabel } from '@/shared/lib/persona-label';

interface Props {
  data: BehindTheAnswerWidgetSchemaType;
}

/**
 * Store-free, prop-only preview of a behind-the-answer widget: the persona
 * heading plus the main takeaway. Renders props.data only.
 */
export const BehindTheAnswerThumbnail = (props: Props) => {
  const { t } = useTranslation('common');
  const { personaTitle, segmentName, mainTakeAway } = props.data;
  const heading =
    personaLabel({ personaTitle, segmentName }, ', ') ||
    t('artifact.artifactKindPalette.interview');

  return (
    <div className="flex h-full flex-col gap-2 overflow-hidden">
      <p className="truncate text-sm font-semibold text-[#1A1A1A]">{heading}</p>
      <p className="line-clamp-3 text-xs text-[#1A1A1A]">{mainTakeAway}</p>
    </div>
  );
};
